var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"jgaq85cdT5kGgx4VUH-Az"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["emak-frontend@webranking-srl"]={id:"jgaq85cdT5kGgx4VUH-Az"};
      